import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stSettlementCycles } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingSettlementCycles;

export const settlementCyclesDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 10 } = params.pagination || {};
    const status = (params.filter?.status as string | undefined) || undefined;
    const roomId = (params.filter?.roomId as string | undefined) || undefined;
    const res = await stSettlementCycles({
      status,
      roomId,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
